import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { getCurrentCulture } from "@utils";
import { DepositContext } from "@state/context/payment/DepositContext";

export default observer(function DepositBonusConfirmation() {
	const { currentFormData, selectedPaymentMethod, depositBonusInfo } =
		useContext(DepositContext);

	const { t } = useTranslation("payment");

	const { register } = useFormContext();

	if (!depositBonusInfo?.isUserQualifiedForDepositBonus) {
		return (
			<div className="message message--base message--note u-mar--bottom--xsml">
				<i className="message__icon u-icon u-icon--lrg u-icon--info-circle u-color--sent--note" />
				<div className="message__content">
					<div className="message__title">
						{t("NOT_ELIGIBLE_FOR_BONUS")}
					</div>
					<Link
						to={`/${getCurrentCulture()}/info/bonus-terms`}
						target="_blank"
						className="message__btn btn btn--sml btn--primary--inverted"
					>
						{t<string>("DEPOSIT.BONUS_TERMS")}
					</Link>
				</div>
			</div>
		);
	}

	return (
		<>
			<div className="message message--base message--note u-mar--bottom--xsml">
				<i className="message__icon u-icon u-icon--lrg u-icon--info-circle u-color--sent--note" />
				<div className="message__content">
					<div className="message__title">
						{t("DEPOSIT.BONUS_MAX_INFO", {
							0: depositBonusInfo?.bonusInfo.bonusPercentage,
							1: depositBonusInfo?.bonusInfo.maxBonusAmount,
							2: selectedPaymentMethod?.currencyDisplayCode,
						})}
					</div>
					<div className="message__text">
						{t("DEPOSIT.BONUS_AMOUNT_INFO", {
							0: currentFormData?.amount,
							1: selectedPaymentMethod?.currencyDisplayCode,
							2: depositBonusInfo?.bonusInfo.bonusAmount,
						})}
					</div>
					<Link
						to={`/${getCurrentCulture()}/info/bonus-terms`}
						target="_blank"
						className="message__btn btn btn--sml btn--primary--inverted"
					>
						{t<string>("DEPOSIT.BONUS_TERMS")}
					</Link>
				</div>
			</div>
			<div className="form__group">
				<div className="input--check">
					<input
						id="bonus"
						type="checkbox"
						className="input--check__box"
						{...register("isBonusAccepted")}
					/>
					<label htmlFor="bonus" className="input--check__label">
						{t("DEPOSIT.BONUS_ACCEPTANCE")}
					</label>
				</div>
			</div>
		</>
	);
});
